import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { PlatformRoute } from "../../routing/IndividualRoutes";

export class PlatformPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <PlatformRoute />
      </Fragment>
    );
  }
}
